import {useMemo} from "react";


// Хук для расчета итогов

export const useTotalsCalculator = (staffAmounts) => {
    return useMemo(() => {
        let totalCash = 0;
        let totalNonCashWithoutVAT = 0;
        let totalNonCashWithVAT = 0;

        Object.values(staffAmounts).forEach(amounts => {
            totalCash += amounts.cash || 0;
            totalNonCashWithoutVAT += amounts.nonCashWithoutVAT || 0;
            totalNonCashWithVAT += amounts.nonCashWithVAT || 0;
        });

        const totalAmount = totalCash + totalNonCashWithVAT;

        return {
            totalCash: Math.round(totalCash * 100) / 100,
            totalNonCashWithoutVAT: Math.round(totalNonCashWithoutVAT * 100) / 100,
            totalNonCashWithVAT: Math.round(totalNonCashWithVAT * 100) / 100,
            totalAmount: Math.round(totalAmount * 100) / 100
        };
    }, [staffAmounts]);
};